<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': applications.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Application list') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th scope="col">{{ i18n('Id') }}</th>
            <th scope="col">{{ i18n('Alias') }}</th>
            <template v-if="$root?.features?.applications?.categories?.enabled">
              <th scope="col">{{ i18n('Category') }}</th>
              <th scope="col">{{ i18n('Subcategory') }}</th>
            </template>
            <th scope="col">{{ i18n('Url') }}</th>
            <th scope="col">{{ i18n('Profiles') }}</th>
            <th scope="col">{{ i18n('Created At') }}</th>
            <template v-if="$root?.features?.loginPortal?.enabled">
              <th scope="col">{{ i18n('Show in login') }}</th>
              <th scope="col">{{ i18n('Order') }}</th>
            </template>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ApplicationListItem v-for="application in applications" :application="application" :key="application.id"
            @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" />
          <EmptyListItem v-if="!applications || applications.length == 0" :loading="loading"
            :colspan="6 + ($root?.features?.applications?.categories?.enabled ? 2 : 0)" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad"
            :colspan="6 + ($root?.features?.applications?.categories?.enabled ? 2 : 0)" @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
    <Pagination cssClass="mt-2" v-if="pagination && pagination.singlePage && pagination.limit < pagination.total"
      :pagination="pagination" :loading="loading" @goToPage="(...args) => $emit('goToPage', ...args)" />
  </div>
</template>

<script>
import ApplicationListItem from "@/components/application/ApplicationListItem.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Pagination from "@/components/common/list/Pagination.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    ApplicationListItem,
    EmptyListItem,
    LazyLoadListItem,
    Pagination,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
    'goToPage',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    pagination: Object,
    applications: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
  },
};
</script>